import moment from 'moment';

type DateInput = Date | string;

/**
 * Week view renders shifts as full-day blocks, so the dropped position only tells us which day
 * the shift moved to. FullCalendar's `delta` can't be used here: the '24:00:00' slot/snap duration
 * is parsed as milliseconds, so `delta.days` is always 0. Compare calendar days instead and shift
 * the real times by whole days (keeps time-of-day intact, including across DST changes).
 */
export const getWeekViewDropTimes = (
	actualStart: DateInput,
	actualEnd: DateInput,
	oldDisplayStart: DateInput,
	newDisplayStart: DateInput
): { start: Date; end: Date } => {
	const daysDiff = moment(newDisplayStart)
		.startOf('day')
		.diff(moment(oldDisplayStart).startOf('day'), 'days');

	return {
		start: moment(actualStart).add(daysDiff, 'days').toDate(),
		end: moment(actualEnd).add(daysDiff, 'days').toDate(),
	};
};
